"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimAminoSignDoc = void 0;
const joi_1 = __importDefault(require("joi"));
const TrimAminoSignDocScheme = joi_1.default.object({
    chain_id: joi_1.default.string().allow(""),
    account_number: joi_1.default.string().allow(""),
    sequence: joi_1.default.string().allow(""),
    fee: joi_1.default.object({
        amount: joi_1.default.array().items(joi_1.default.object({
            denom: joi_1.default.string().allow(""),
            amount: joi_1.default.string().allow(""),
        })),
        gas: joi_1.default.string().allow(""),
        payer: joi_1.default.string().allow(""),
        granter: joi_1.default.string().allow(""),
        // XXX: "feePayer" should be "payer". But, it maybe from ethermint team's mistake.
        //      That means this part is not standard.
        feePayer: joi_1.default.string().allow(""),
    }),
    msgs: joi_1.default.array().items(joi_1.default.any()),
    memo: joi_1.default.string().allow(""),
    timeout_height: joi_1.default.string().allow(""),
});
/**
 * Trim unknown fields from sign doc.
 * The purpose of this function is not validate the sign doc, but only trim unknown fields.
 * @param signDoc
 */
function trimAminoSignDoc(signDoc) {
    const res = TrimAminoSignDocScheme.validate(signDoc, {
        stripUnknown: true,
    });
    if (res.error) {
        throw res.error;
    }
    return res.value;
}
exports.trimAminoSignDoc = trimAminoSignDoc;
//# sourceMappingURL=amino-sign-doc.js.map